import {
    LINKEDCALENDARV2_ENTRY_TYPENAME,
    LOCALCACHEFORREMOTECALENDAR_ENTRY_TYPENAME,
    LINKEDCALENDAR_ENTRY_TYPENAME,
} from './constants';

/**
 * Returns whether provided calendar is a shared calendar or not
 * @param calendarEntry, the calendar entry
 * @returns true if calendar shared calendar ( old model, new model or hybrid)
 */
export const isSharedCalendar = (calendarEntry?: {
    __typename?: string;
    IsGroupMailboxCalendar?: boolean | null;
}): boolean => {
    return (
        !calendarEntry?.IsGroupMailboxCalendar &&
        (calendarEntry?.__typename == LINKEDCALENDARV2_ENTRY_TYPENAME ||
            calendarEntry?.__typename == LINKEDCALENDAR_ENTRY_TYPENAME ||
            calendarEntry?.__typename == LOCALCACHEFORREMOTECALENDAR_ENTRY_TYPENAME)
    );
};
